<div class="main-body">
  <div *ngFor="let app of applications let i = index" class="application-container m-4 text-center">
    <div class="application">
      <div style="padding:5px" class="d-flex; align-items-center h-100">
        <div>
          <img (dblclick)="openApplicationSession(app)" src="{{app.icon}}" width="100px" height="100px" style="border-radius: 50%; background-color: white; padding: 5px">
        </div>
        <div>
          <p style="font-size:1.3em; margin-left: 5%">{{app.name}}</p>
        </div>
      </div>
    </div>
  </div>
</div>